var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 6.22014C13.0976 6.61066 13.0976 7.24383 12.7071 7.63435L9.41421 10.9272L12.7071 14.2201C13.0976 14.6107 13.0976 15.2438 12.7071 15.6344C12.3166 16.0249 11.6834 16.0249 11.2929 15.6344L7.29289 11.6344C6.90237 11.2438 6.90237 10.6107 7.29289 10.2201L11.2929 6.22014C11.6834 5.82962 12.3166 5.82961 12.7071 6.22014Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.05320364eefdd751e8de54c4b48d6b6f.svg";
export { ForwardRef as ReactComponent };